.noteEditorBox {
  border-right: 2px solid var(--tuna-palette-primary-main);
  margin-top: 8px;
  margin-bottom: 8px;
  padding: 8px;
  flex: 1;
  display: flex;
}

.flex1 {
  flex: 1;
}
